import { Description, Svg } from '@repo/ui';

export const EmptyRefundHistory = () => {
  return (
    <section className={'py-spacious-medium'}>
      <Description
        size="medium"
        graphic={<Svg src="icg_document-dimmed_md.svg" width={80} height={80} />}
        title="환급받은 내역이 없어요"
        description={'비즈넵 환급에서 결제를 완료한\n환급 내역만 볼 수 있어요.'}
      />
    </section>
  );
};
